/*
 * SB Familienbewertungen – Karussell-Steuerung.
 * Progressive Verbesserung: Ohne JavaScript bleibt der Bereich nativ horizontal
 * scrollbar (Touch, Trackpad, Pfeiltasten nach Fokus). Keine automatische Bewegung.
 * Pfeil-Buttons (Desktop/Tablet) und Fortschrittsbalken (mobil, per CSS) werden
 * nur eingeblendet, wenn es tatsächlich etwas zu scrollen gibt.
 */
(function () {
  'use strict';
  if (window.SbFamilyReviews) return;

  var reduceMotion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

  function init(root) {
    if (!root || root.getAttribute('data-sb-ready') === 'true') return;
    var viewport = root.querySelector('[data-sb-viewport]');
    var controls = root.querySelector('[data-sb-controls]');
    if (!viewport || !controls) return;
    var prev = controls.querySelector('[data-sb-prev]');
    var next = controls.querySelector('[data-sb-next]');
    if (!prev || !next) return;
    var progress = root.querySelector('[data-sb-progress]');
    root.setAttribute('data-sb-ready', 'true');

    function stepSize() {
      var card = viewport.querySelector('.sb-review');
      if (!card) return viewport.clientWidth;
      var gap = parseFloat(window.getComputedStyle(card.parentElement).columnGap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function update() {
      var overflow = viewport.scrollWidth > viewport.clientWidth + 2;
      controls.hidden = !overflow;
      if (progress) {
        progress.hidden = !overflow;
        if (overflow) {
          progress.style.setProperty('--sb-progress-width', (viewport.clientWidth / viewport.scrollWidth) * 100 + '%');
          progress.style.setProperty('--sb-progress-left', (viewport.scrollLeft / viewport.scrollWidth) * 100 + '%');
        }
      }
      if (!overflow) return;
      var active = document.activeElement;
      prev.disabled = viewport.scrollLeft <= 2;
      next.disabled = viewport.scrollLeft >= viewport.scrollWidth - viewport.clientWidth - 2;
      if (active === prev && prev.disabled) next.focus();
      if (active === next && next.disabled) prev.focus();
    }

    function go(direction) {
      viewport.scrollBy({
        left: direction * stepSize(),
        behavior: reduceMotion && reduceMotion.matches ? 'auto' : 'smooth'
      });
    }

    prev.addEventListener('click', function () { go(-1); });
    next.addEventListener('click', function () { go(1); });

    var queued = false;
    viewport.addEventListener('scroll', function () {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () {
        queued = false;
        update();
      });
    }, { passive: true });

    if ('ResizeObserver' in window) {
      new ResizeObserver(update).observe(viewport);
    } else {
      window.addEventListener('resize', update);
    }
    update();
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-sb-reviews]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  window.SbFamilyReviews = { init: initAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
